import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    headerMenuList: [],
    mobileMenu:[],
    linkList:[],
    logo:'',
    infoRes:{},
    rowMenuList:[
      // {type_name:'协会'}
    ],
    magazineList:[],
    validToken:false,//判断token是否失效的标志
    token:'',
    user_id:'',
    userInfo:{},
    msgNum:0,
    isDialogVisible:false,
    screenWidth: '',
    isPc:false
  },
  mutations: {
  },
  actions: {
    checkWindowWidth(context){
      context.state.screenWidth = document.body.clientWidth;
      context.state.isPc=context.state.screenWidth>768?true:false
      window.onresize = () => {
        return (() => {
          context.state.screenWidth = document.body.clientWidth;
          context.state.isPc=context.state.screenWidth>768?true:false
        })();
      };
    },
    // 获取首页顶部导航栏菜单和底部友情链接
    async getNavigate(context) {
			const { data: res } =  await axios.get(
        `/api/v2/website/navigate?association_id=SZTX`
      );
      // console.log(res);
      if (res.code !== "200") return this.$message.error(res.msg);
      context.state.headerMenuList = res.data.filter((item) => item.type === "INDEX");
      context.state.mobileMenu = res.data.filter((item) => item.type === "INDEX");
      context.state.mobileMenu[0]={
        name:'登錄',
        url:'/login'
      }
      context.state.mobileMenu.push({
        name:'個人中心',
        url:'/person_center'
      })
      context.state.linkList = res.data.filter((item) => item.type === "FRIENDLINK");
      
    },
    //获取协会相关信息=====logo，企业旁菜单栏，底部信息
    async getProfile(context) {
      const { data: res } = await axios.get(
        `/api/v2/website/profile?association_id=SZTX`
      );
      // console.log(res);
      if (res.code !== "200") return this.$message.error(res.msg);
      context.state.infoRes = JSON.parse(res.data[0].context);
      context.state.logo = JSON.parse(res.data[1].context).url;
      context.state.rowMenuList = JSON.parse(res.data[2].context);
    },
    //验证token是否失效
    async checkToken(context) {
      const { data: res } = await axios.post(`/api/v2/account/inquire/${window.sessionStorage.getItem("token")}`);
      // console.log('验证token是否失效====',res);
      if (!res.sucess){
        context.state.validToken=false
        return false;
      } 
      context.state.validToken=true
      context.state.user_id = res.data.user_id;
      //获取用户信息
      const { data: result } = await axios.get(`/api/v2/member/${context.state.user_id}`);
      // console.log('获取用户信息===',result);
      if (result.code !== "200") return false;
      context.state.userInfo=result.data
      //获取用户通知信息个数
      const { data: results } = await axios.get(`/api/v2/notice/count/${context.state.user_id}`);
      // console.log('获取用户通知信息个数===',results);
      if (results.code !== "200") return false;
      context.state.msgNum=results.data[0].noticeCount
    },
  },
  modules: {
  }
})
